import styled from "styled-components"

import { when } from "utils"

export const Container = styled.div`
  width: 100%;
  min-height: 3.9rem;
  padding: 0.7rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ccd6da;
  color: #003445;

  p {
    margin: 0px;
  }

  ${when("isPrimary")`
    min-height: 3.1rem;
    background-color:  #003445;
    color: white;
  `}
`
